// Loqate/Addressy's AdminAreaName field is not a dedicated "county" value - for
// low-precision US matches (rural addresses, truncated postal codes) it falls
// back to returning the state name/code in that same slot. Reject it in that case
// so a state value never gets written into the county field.
export function sanitizeCounty(address) {
    let county = address.AdminAreaName;
    if (!county || address.CountryIso2 !== 'US') {
        return county;
    }

    let normalized = county.trim().toLowerCase();
    let stateCode = (address.ProvinceCode || '').trim().toLowerCase();
    let stateName = (address.ProvinceName || address.Province || '').trim().toLowerCase();

    if (normalized === stateCode || normalized === stateName) {
        return '';
    }

    return county;
}

// County is only meaningful for US addresses - other countries leave it optional.
export function isCountyValid(addr) {
    if (!addr || addr.country_cd !== 'US') {
        return true;
    }

    return !!(addr.county && String(addr.county).trim().length > 0);
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/address/sanitizeCounty.js